import React from 'react'

import Tip from '../components/Tip'
import SkinThumb from '../components/SkinThumb'
import Button from '../components/Button'
import CloseButton from '../assets/close-button.svg'
import './SkinPage.css'

class SkinPage extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: 0,
    }
  }
  static defaultProps = {
    setWrapperState: () => {},
  }

  onNext() {
    this.props.setWrapperState({
      currPage: 5,
      skinType: this.state.selected,
    })
  }

  onBack() {
    var prevPage = this.props.data.prevPageIndex
    this.setState({ selected: 0 })
    this.props.setWrapperState({
      currPage: prevPage,
    })
  }

  handleSelect(num) {
    this.setState({
      selected: num,
    })
  }

  skinTypes(data) {
    var option = data.options.find(op => op.gender === this.props.gender)
    if (!option) {
      option = data.options[0]
    }
    return option.options
  }

  getTip(data, selected) {
    var option
    if ((selected !== undefined ? selected : this.state.selected) > 0) {
      option = data.options.find(op => op.gender === this.props.gender)
      if (!option) {
        option = data.options[0]
      }
      return option.options.find(
        op =>
          op.index === (selected !== undefined ? selected : this.state.selected)
      ).tip
    } else {
      return data.tipContent
    }
  }

  handleSkinClick(e, i, { description, ...type }, data) {
    const modalContent = (
      <React.Fragment>
        <div className="modalContent">
          <img
            src={CloseButton}
            className="closeModal"
            alt="Close Modal"
            onClick={() => this.props.setWrapperState({ modalOpen: false })}
          />
          <div style={{ display: 'inline-block' }}>
            <SkinThumb {...type} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              marginLeft: 8,
            }}
          >
            <div className="modalSkinTip">
              <p className="modalTipHeader">{description}</p>
              {this.getTip(data, i + 1)}
            </div>
            <div className="modalFooter">
              <Button
                shape="round"
                variant="blue"
                onClick={() => {
                  this.props.setWrapperState({ modalOpen: false })
                  this.handleSelect(type.index)
                }}
              >
                {data.modalSelect || 'SELECT'}
              </Button>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
    this.props.setWrapperState({ modalOpen: true, modalContent })
  }

  render() {
    const { selected } = this.state
    const { data } = this.props
    const tip = this.getTip(data)
    return (
      <div>
        <h1>{data.header}</h1>
        {data.topTip && <div className="toptip">{data.topTip.content}</div>}
        <div>
          <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            {this.skinTypes(data).map((type, index) => {
              return (
                <div
                  key={index}
                  className={
                    'skinThumbWrapper' +
                    (selected === index + 1 ? ' selected' : '')
                  }
                  onClick={e => this.handleSkinClick(e, index, type, data)}
                >
                  <SkinThumb {...type} />
                </div>
              )
            })}
          </div>
        </div>
        {
          //The "false" below is just to disable showing the tip at the
          //bottom because it's moved into a modal for now
          //I have a feeling that it may be moved back here later so I'm keeping the code
        }
        {false && data.tipHeader && tip && (
          <Tip marginTop="100px" title={data.tipHeader} reference={data.references}>
            {tip}
          </Tip>
        )}

        <div className="footer">
          <div className="bottomButtons">
            <div>
              {!!data.prevButton && (
                <Button shape="round" onClick={() => this.onBack()}>
                  {data.prevButton}
                </Button>
              )}
            </div>
            <Button
              shape="round"
              variant="blue"
              onClick={() => this.onNext()}
              disabled={selected === 0}
            >
              {data.nextButton}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default SkinPage
